// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormLabel_wrapper__2BKUu","right":"FormLabel_right__R4wHQ","label":"FormLabel_label__A3aJr","error":"FormLabel_error__2oEN7"};